import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardConfig from 'common/components/card-config';
import CardContent from 'common/components/card-content';
import {useAutoHeight} from './hooks';
import './index.scss';

// iframe sandbox:
// allow-popups: allow links with target="_blank"
// allow-forms: allow users to login to various services

const identity = (x) => x;

// Constants used as iframe attributes to (dis)allow scrolling
const SCROLLING_ENABLED = 'yes';
const SCROLLING_DISABLED = 'no';

const IframeCard = ({
  connectDragSource,
  disableConfig,
  disableHyperlinks,
  height,
  report,
  scrolling,
  src,
}) => {
  const sandbox = `allow-same-origin allow-scripts ${
    disableHyperlinks ? '' : 'allow-popups allow-forms'
  }`;
  const frameElementName = `iframe-${report.id}`;
  useAutoHeight(frameElementName);
  return (connectDragSource || identity)(
    <div className={'IframeCard'}>
      <Card className={'IframeCard-Card Card--corner-menu'} loading={false}>
        <CardConfig
          className={'IframeCard-CardConfig'}
          disableConfig={disableConfig}
          disableDownload={true}
          disableDownloadCsv={true}
          disableDownloadPointsCsv={true}
          reportId={report.id}
        />
        <CardContent className={'IframeCard-CardContent'} key={`card-content`}>
          <iframe
            className={'IframeCard-iframe'}
            height={height}
            name={frameElementName}
            sandbox={sandbox}
            scrolling={scrolling ? SCROLLING_ENABLED : SCROLLING_DISABLED}
            src={src}
          />
        </CardContent>
      </Card>
    </div>,
  );
};

IframeCard.propTypes = {
  connectDragSource: PropTypes.func,
  disableConfig: PropTypes.bool,
  disableHyperlinks: PropTypes.bool,
  height: PropTypes.number,
  report: PropTypes.any,
  scrolling: PropTypes.bool,
  src: PropTypes.string.isRequired,
};

IframeCard.defaultProps = {
  disableConfig: false,
  disableHyperlinks: false,
  height: 0,
  scrolling: true,
};

export default IframeCard;
